export default __webpack_public_path__ + "static/media/9.978d1667.jpg";